import PropTypes from 'prop-types'

export const AddressPropTypes = PropTypes.shape({
  streetLine: PropTypes.string,
  sublocality: PropTypes.string,
  locality: PropTypes.string,
  governingDistrict: PropTypes.string,
  postalCode: PropTypes.string,
})

export default AddressPropTypes
